// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_service".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "appointment_service" table (1:1 with a DB row, on the wire). */
export const appointmentServiceAtomSchema = z.object({
    id: z.string(),
    appointmentId: z.string(),
    serviceId: z.string().nullable(),
    name: z.string(),
    durationMinutes: z.number(),
    priceCents: z.number().nullable(),
    originalPriceCents: z.number().nullable(),
    offerId: z.string().nullable(),
    paymentSnapshot: z.unknown().nullable(),
    offerRedemptionReleasedAt: z.string().datetime().nullable(),
    clientPackageId: z.string().nullable(),
    practitionerId: z.string().nullable(),
    sortOrder: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentService.js.map